import React from 'react';

import { SCHEDULED_GAME_LOCK_TOOLTIP } from '../scheduled/scheduledGameCopy';

/**
 * Indicates a court/upcoming slot's roster is locked because it is tied to a scheduled
 * game. Cancelling the scheduled game (Manage → Scheduled games) is the only way to
 * change the lineup — see cancel_scheduled_game RPC and isScheduledGameLinkedSlot.
 */
function ScheduledGameLockBadge() {
  return (
    <span
      className="inline-flex shrink-0 items-center gap-1 rounded-full border border-info bg-info-light px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-info-dark cursor-help"
      title={SCHEDULED_GAME_LOCK_TOOLTIP}
      role="img"
      aria-label={SCHEDULED_GAME_LOCK_TOOLTIP}
    >
      🔒 Scheduled
    </span>
  );
}

export default React.memo(ScheduledGameLockBadge);
